<div class="dashboard-shell">
  <aside class="dashboard-sidebar">
    <div class="dashboard-sidebar__brand">
      <span class="dashboard-sidebar__title">Gamers Brawl</span>
      <span class="dashboard-sidebar__subtitle">Admin Center</span>
    </div>

    <p-menu [model]="items" styleClass="admin-menu"></p-menu>

    <p-button
      label="Sair"
      icon="pi pi-sign-out"
      styleClass="p-button-danger p-button-text admin-logout"
      (click)="logout()"></p-button>
  </aside>

  <main class="dashboard-content admin-surface">
    <div class="dashboard-content__inner">
      <router-outlet></router-outlet>
    </div>
  </main>
</div>
